import { LandingTranslate } from './landingTranslate.model';

const landingTranslateEN: LandingTranslate = {
  nav: {
    features: 'Features',
    how: 'How it works',
    pricing: 'Pricing',
    faq: 'FAQ',
    login: 'Log in',
    signup: 'Start free',
    goToApp: 'Go to app',
    menu: 'Menu',
    closeMenu: 'Close menu',
    language: 'Language',
    theme: 'Theme',
  },
  hero: {
    badge: 'Open beta · free for the first 100 studios',
    headline: 'Stop losing clients in WhatsApp.',
    sub: 'The CRM made for photography. From first contact to delivery, everything in one place — leads, events, contracts and payments.',
    ctaPrimary: 'Start free',
    ctaSecondary: 'See how it works',
    b1: 'No credit card',
    b2: '2-min setup',
    b3: 'You own your data',
  },
  mockup: {
    address: 'app.clickersphere.com / events',
    colScheduled: 'Scheduled',
    colEditing: 'Editing',
    colDelivered: 'Delivered',
    weddingTitle: 'Wedding Marina & Pedro',
    weddingDate: 'Apr 26 · 4:00 PM',
    newbornTitle: 'Newborn Beatriz',
    newbornDate: 'Apr 27 · 10:00 AM',
    bookTitle: 'Corp. book Rafael',
    bookDate: 'Apr 29 · 9:00 AM',
    portraitTitle: 'Portrait Carolina',
    portraitDetail: 'Shoot confirmed · 2pm',
    birthdayTitle: 'Sweet 15',
    birthdayDeadline: 'Deadline · May 02',
    familyTitle: 'Souza Family',
    familyDetail: 'Contract signed',
    graduationTitle: 'Graduation Lucas',
    graduationDetail: 'Paid · $560',
    leadTime: '09:41',
    leadStatus: 'Events',
    revenueLabel: '+$960',
    leadCount: '2 active',
    leadName: 'Marina Alves',
    leadSource: 'New lead · Instagram',
    phoneTitle: 'Events',
    phoneActive: '2 active',
    phoneRevenue: '+$960',
  },
  stats: {
    v1: '2 min',
    v2: '0',
    v3: '7 days',
    v4: '100',
    s1: 'To get started',
    s2: 'Spreadsheets needed',
    s3: 'Free to try',
    s4: 'Beta spots',
  },
  problem: {
    eyebrow: 'THE PROBLEM',
    title: "You're a photographer. Not an admin.",
    sub: "But every month you waste hours digging through WhatsApp, spreadsheets and email just to remember who's who.",
    p1: { k: 'Today', v: '"Wait, is Marina\'s shoot on the 24th or 26th?"' },
    p2: { k: 'Today', v: '3 WhatsApp threads for a single quote' },
    p3: { k: 'Today', v: 'Excel + Google Calendar + a tiny notebook' },
    p4: { k: 'Today', v: 'Lead disappears because you missed a 2-day reply' },
  },
  features: {
    eyebrow: 'FEATURES',
    title: "Everything a studio needs. Nothing it doesn't.",
    sub: 'No bloated generic CRM. No 4 separate tools. Just the essentials — polished.',
    f1: {
      t: 'Lead pipeline',
      d: 'Add a client in 4 fields. Mark as active, read notes, see event history. Done.',
    },
    f2: {
      t: 'Event board',
      d: 'Drag-and-drop kanban. Create your own columns: scheduled, editing, proof, delivered, paid — your way.',
    },
    f3: {
      t: 'Home dashboard',
      d: "Monthly leads, week's events, upcoming deadlines. Open the app and know your day in 3 seconds.",
    },
    f4: {
      t: 'Email reminders',
      d: 'Get alerts for upcoming tasks and installments right in your inbox. Nothing slips.',
    },
    f5: {
      t: 'Multi-organization',
      d: 'More than one studio? White label? Switch tenant in 1 click, isolated data.',
    },
    f6: {
      t: 'Light & dark mode',
      d: 'Editing photos at 11pm? Dark mode was made for this.',
    },
  },
  how: {
    eyebrow: 'HOW IT WORKS',
    title: 'From "hi" in DM to "paid" — in 3 steps.',
    s1: {
      label: 'Capture',
      t: 'Save the lead',
      d: 'Name, email, Instagram, notes. 30 seconds. Saved in history.',
    },
    s2: {
      label: 'Organize',
      t: 'Turn into event',
      d: 'Drag on the board: scheduled → editing → delivered. Statuses you invent.',
    },
    s3: {
      label: 'Deliver',
      t: 'Track on the dashboard',
      d: 'See estimated revenue, conversion rate and delivery deadlines — no formula.',
    },
  },
  diff: {
    eyebrow: 'WHY NOT A GENERIC CRM?',
    title: "Because a newborn shoot isn't a B2B sale.",
    sub: "Hubspot, Pipedrive and Notion do everything — and that's exactly the problem. Clicker Sphere is shaped around the real flow of working photographers.",
    col1: ' ',
    col2: 'Generic CRM',
    col3: 'Clicker Sphere',
    r1: 'Vocabulary',
    r1a: 'Deal · Lead · Stage',
    r1b: 'Client · Event · Delivery',
    r2: 'Setup',
    r2a: 'Hours building pipelines',
    r2b: '2 minutes, presets ready',
    r3: 'Statuses',
    r3a: 'Fixed or paid add-on',
    r3b: 'Create whatever you want',
    r4: 'Learning curve',
    r4a: '40-min tutorial',
    r4b: 'Open it, use it',
    r5: 'Focus',
    r5a: 'Sales in general',
    r5b: 'Photography, period.',
  },
  tst: {
    eyebrow: 'BETA',
    title: 'First beta studios.',
    body: 'Your studio could be here. The first 100 get free access and a direct line to the people building the product.',
    cta: 'Join the beta (free)',
  },
  pr: {
    eyebrow: 'PRICING',
    title: 'Simple. Honest. Cancel anytime.',
    sub: 'During beta, everything is free. These will be the launch prices — join now and lock the value forever.',
    month: '/mo',
    popular: 'Most popular',
    guarantee:
      '7-day free trial on paid plans · no credit card · cancel anytime',
    t1: {
      name: 'Solo',
      price: 'R$0',
      d: 'Forever, during beta',
      f1: '1 organization',
      f2: 'Up to 15 active leads',
      f3: 'Unlimited event boards',
      f4: 'Basic dashboard',
      cta: 'Start free',
    },
    t2: {
      name: 'Studio',
      price: 'R$29.90',
      d: 'Yearly: R$299 (2 months free)',
      f1: 'Everything in Solo, unlimited',
      f2: 'Custom statuses',
      f3: 'Full dashboard + metrics',
      f4: 'PDF contracts with templates',
      f5: 'Priority support',
      cta: 'Join the beta (free)',
    },
    t3: {
      name: 'Collective',
      price: 'R$79.90',
      d: 'Yearly: R$799 · teams & white label',
      f1: 'Everything in Studio',
      f2: 'Multiple organizations',
      f3: 'Role-based permissions',
      f4: 'Data export',
      f5: '24h SLA',
      cta: 'Join the beta (free)',
    },
  },
  faq: {
    eyebrow: 'FAQ',
    title: 'Everything you want to know before starting.',
    q1: 'Does Clicker Sphere replace WhatsApp?',
    a1: 'No. WhatsApp is where you talk. Clicker Sphere is where the conversation becomes a lead, an event and a delivery — so nothing slips.',
    q2: 'Can I create my own event statuses?',
    a2: 'Yes, on paid plans. Create as many columns as you want, reorder by drag, set color and icon. Each studio runs it their way.',
    q3: 'Is my data shared with anyone?',
    a3: 'Never. Each organization is isolated from the others. Export everything as CSV whenever you want (paid plans) and cancel in 1 click.',
    q4: 'Does it work on mobile?',
    a4: 'Yes. Beyond the web app, we have a native iOS and Android app — carry your events in your pocket.',
    q5: 'I already use another CRM. Can I migrate?',
    a5: 'You export everything as CSV whenever you want (paid plans). Migrating from a spreadsheet, Hubspot or Pipedrive? On the Collective plan we handle the migration for you.',
  },
  cta: {
    title: 'Less spreadsheet. More shutter.',
    sub: '2 minutes to create your account. Zero commitment. Cancel anytime.',
    primary: 'Start now',
    secondary: 'Back to features',
  },
  ft: {
    about:
      'A minimalist CRM for photographers. Made by people tired of spreadsheets.',
    product: 'Product',
    company: 'Company',
    legal: 'Legal',
    contact: 'Contact',
    terms: 'Terms',
    privacy: 'Privacy',
    lgpd: 'LGPD',
    copy: '© 2026 Clicker Sphere. All rights reserved.',
    version: 'beta',
  },
};

export default landingTranslateEN;
